import React from "react";
import { Link } from "react-router-dom";

/**
 * 自社所有の土地・物件を「不動産事業」で掲載中であることの告知カード。
 * メインページ・事業内容ページで共通利用（表現の一貫性のため単一化）。
 * @param {{ className?: string }} props
 */
const OwnPropertyNotice = ({ className = "" }) => (
  <div
    className={`max-w-2xl mx-auto rounded-lg border border-gray-200 bg-gray-50 p-5 text-center ${className}`}
  >
    <p className="text-gray-700 leading-relaxed">
      自社で保有する<span className="font-semibold">土地・物件</span>を
      <span className="font-semibold">「不動産事業」</span>にて掲載中です。
    </p>
    <p className="text-sm text-gray-500 mt-1">
      売買をご検討の方は、ぜひ掲載中の物件をご覧ください。
    </p>
    <Link
      to="/businessContent/real-estate"
      className="inline-block mt-3 bg-primary text-white px-5 py-2 rounded-md hover:opacity-90 transition"
    >
      掲載中の物件を見る →
    </Link>
  </div>
);

export default OwnPropertyNotice;
